import type { EmbeddedAuthTokenResult } from '@/platform/authentication/MsalPopupAuthService';

interface SessionByProduct {
  [productId: string]: EmbeddedAuthTokenResult;
}

class SessionManager {
  private sessions: SessionByProduct = {};

  getSession(productId: string): EmbeddedAuthTokenResult | null {
    return this.sessions[productId] ?? null;
  }

  upsertSession(productId: string, session: EmbeddedAuthTokenResult): void {
    this.sessions = {
      ...this.sessions,
      [productId]: session,
    };
  }

  clearSession(productId: string): void {
    if (!(productId in this.sessions)) {
      return;
    }

    const nextSessions = { ...this.sessions };
    delete nextSessions[productId];
    this.sessions = nextSessions;
  }

  clearAll(): void {
    this.sessions = {};
  }
}

export const sessionManager = new SessionManager();
